import React, { Component } from 'react';
import { Alert, Modal } from "react-bootstrap";
import {FaRegCheckCircle} from 'react-icons/fa';

const SuccessAlert = (props) => {

    const { alertBody } = props;

    return (
        <Modal {...props} animation={true} id="alertBox" size="md" centered>
            <Modal.Body>
                <Alert>
                    <Alert.Heading className="mb-0 fs-20">
                        <FaRegCheckCircle className='mb-2 pb-4 checkIcon' style={{fontSize: '80px'}} />
                        <p className='mb-2'>Success !!</p>
                    </Alert.Heading>
                    <p className="d-flex justify-content-center mt-4">{`${alertBody}`}</p>
                </Alert>
            </Modal.Body>
        </Modal>
    )
}

export default SuccessAlert;